Vendd.Scripts.load(function () {

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.BindControl, 'product-details-add-ons', function (envelope) {
        var $context = envelope.message.data.context,
            $control = $('.x-product-details-add-ons', $context);

        if ($control.length < 1)
            return;

        $.each($control, function (i, control) {

            $(".js-checkbox-add-on", control).change(function () {
                if ($(this).is(':checked')) {
                    $('.x-product-details-ajax-buttons .js-add-to-cart', $context).addClass('has-add-on-products');
                } else {
                    if ($(".js-checkbox-add-on:checked", $control).length < 1 && ($(".js-select-add-on option:selected", $control).val() == "" || typeof $(".js-select-add-on option:selected", $control).val() === "undefined"))
                        $('.x-product-details-ajax-buttons .js-add-to-cart', $context).removeClass('has-add-on-products');
                }
            });

            $(".js-select-add-on", control).change(function () {

                var option = $(this).find("option:selected");

                if (option.val() != "") {
                    $('.x-product-details-ajax-buttons .js-add-to-cart', $context).addClass('has-add-on-products');
                } else {
                    if ($(".js-checkbox-add-on:checked", $control).length < 1 && ($(".js-select-add-on option:selected", $control).val() == "" || typeof $(".js-select-add-on option:selected", $control).val() === "undefined"))
                        $('.x-product-details-ajax-buttons .js-add-to-cart', $context).removeClass('has-add-on-products');
                }
            });

            //check addon after sku change
            if ($(".js-checkbox-add-on", control).is(":checked"))
                $('.x-product-details-ajax-buttons .js-add-to-cart', $context).addClass('has-add-on-products');

            if ($(".js-select-add-on", control).find("option:selected").length > 0 && $(".js-select-add-on", control).find("option:selected").val() != "")
                $('.x-product-details-ajax-buttons .js-add-to-cart', $context).addClass('has-add-on-products');
        });
        

    });

});
